module.exports = __webpack_public_path__ + "img/download.92f66316.svg";